import { render, staticRenderFns } from "./AddDisable.vue?vue&type=template&id=894520a6&scoped=true&"
import script from "./AddDisable.vue?vue&type=script&lang=js&"
export * from "./AddDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894520a6",
  null
  
)

export default component.exports